import React from 'react';
import { IconButton } from '../common/IconButton';

interface QuantityControlsProps {
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
  minValue?: number;
  className?: string;
}

export const QuantityControls: React.FC<QuantityControlsProps> = ({
  quantity,
  onIncrease,
  onDecrease,
  minValue = 1,
  className = '',
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <IconButton
        variant="ghost"
        size="md"
        onClick={(e) => {
          e.stopPropagation();
          onDecrease();
        }}
        disabled={quantity <= minValue}
        ariaLabel="Diminuer la quantité"
        className="
          border border-gray-300
          hover:border-danger hover:text-danger hover:bg-red-50
          disabled:hover:bg-transparent disabled:hover:border-gray-300 disabled:hover:text-gray-600
        "
      >
        <span className="text-lg font-bold">−</span>
      </IconButton>

      <span className="min-w-[2rem] text-center text-base font-semibold text-gray-900">
        {quantity}
      </span>

      <IconButton
        variant="ghost"
        size="md"
        onClick={(e) => {
          e.stopPropagation();
          onIncrease();
        }}
        ariaLabel="Augmenter la quantité"
        className="
          border border-gray-300
          hover:border-success hover:text-success hover:bg-green-50
        "
      >
        <span className="text-lg font-bold">+</span>
      </IconButton>
    </div>
  );
};
